module.exports = __webpack_public_path__ + "img/bdab1c0.jpg";